import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import {
  MaintenanceBypassService,
  MaintenanceService,
} from '@customer-portal/core';

const CACHE_DURATION_MS = 30_000;
let lastCheckTimestamp = 0;
let pendingCheck: Promise<void> | null = null;

export const maintenanceGuard: CanActivateFn = async () => {
  const maintenanceService = inject(MaintenanceService);
  const maintenanceBypassService = inject(MaintenanceBypassService);

  if (maintenanceBypassService.isBypassed()) {
    return true;
  }

  if (!maintenanceService.isSignalRConnected()) {
    const now = Date.now();
    const timeSinceLastCheck = now - lastCheckTimestamp;

    if (timeSinceLastCheck >= CACHE_DURATION_MS) {
      if (!pendingCheck) {
        pendingCheck = firstValueFrom(
          maintenanceService.checkMaintenanceStatus(),
        ).then(() => {
          lastCheckTimestamp = Date.now();
          pendingCheck = null;
        });
      }

      await pendingCheck;
    }
  }

  return !maintenanceService.isMaintenanceActive();
};
